module.exports = __webpack_public_path__ + "img/3-4.2a6a4e30.svg";